// extracted by mini-css-extract-plugin
export default {"page":"SettingsPage_page__5S2ld","header":"SettingsPage_header__vXeSV","pageTitle":"SettingsPage_pageTitle__48QTq","tabWrapper":"SettingsPage_tabWrapper__MuHBO"};